import React from 'react';
import Modal from '../modal';
import { Desktop, Mobile } from '../../app-responsive';
import { customStylesDesktop, customStylesMobile } from '../business-case-delete-modal/modal-styles-config';

const GenericErrorModal = (props) => {
  const {
    showGenericErrorModal,
    genericErrorModal: {
      title: genericErrorModalTitle,
      content: genericErrorModalContent,
    },
    hideGenericErrorModal,
  } = props;

  const desktopModalStyles = {
    content: {
      ...customStylesDesktop.content,
      width: '530px',
    },
  };

  const modalContent = customStyles => (
    <Modal
      isOpen={showGenericErrorModal}
      onRequestClose={hideGenericErrorModal}
      className="events text-center"
      style={customStyles}
    >
      <h3>{genericErrorModalTitle}</h3>
      <p>{genericErrorModalContent}</p>
    </Modal>
  );

  return (
    <React.Fragment>
      <Mobile>
        {modalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default GenericErrorModal;
